import CONSTANTS from '../constants';
import LoginService from './LoginService';

export default {
  getBinDiscounts,
  getBinDiscountByCodeIfApplicable
};

async function getBinDiscounts(loc_id) {
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.BINDISCOUNTS.DEFAULT(loc_id)}`;
  const token = LoginService.getToken();
  let headers = { ...CONSTANTS.REQUEST_HEADERS };
  if (token) {
    headers['x-access-token'] = token.token;
    url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.BINDISCOUNTS.USER_DEFAULT(loc_id)}`;
  }

  let bindiscounts = await fetch(url, {
    method: 'GET',
    headers: headers
  });
  bindiscounts = await bindiscounts.json();
  if (bindiscounts) return bindiscounts;

  throw new Error('Could not fetch bindiscounts');
}

async function getBinDiscountByCodeIfApplicable(code, loc_id) {
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.BINDISCOUNTS.CHECK(code, loc_id)}`;
  const token = LoginService.getToken();
  let headers = { ...CONSTANTS.REQUEST_HEADERS };
  if (token) {
    headers['x-access-token'] = token.token;
    url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.BINDISCOUNTS.USER_CHECK(code, loc_id)}`;
  }

  let bindiscounts = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers // Include any additional headers
    },
    body: JSON.stringify({
      bin: code
    })
  });
  bindiscounts = await bindiscounts.json();
  if (bindiscounts) return bindiscounts;

  throw new Error('Could not get bindiscounts');
}
